import Vue from "vue";
import Vuex from "vuex";

import appStore from "./stores/app";
import mapStore from "./stores/map";
import infoStore from "./stores/info";
import radarStore from "./stores/radar";
import riverWarnStore from "./stores/RiverWarn";
import telemeterStore from "./stores/Telemeter";
import swinStore from "./stores/Swin";
import inundationStore from "./stores/inundation";
import evacuationStore from "./stores/evacuation";
import tmStore from "./stores/tm";
import snsStore from "./stores/sns";
import viewConfigStore from "./stores/ViewConfig";
import Logger from "./lib/logger";
import Search from "./stores/search";

Vue.use(Vuex);
Vue.use(Logger, process.env.NODE_ENV);

export default new Vuex.Store({
  modules: {
    app: appStore,
    map: mapStore,
    info: infoStore,
    radar: radarStore,
    RiverWarn: riverWarnStore,
    Telemeter: telemeterStore,
    Swin: swinStore,
    inundation: inundationStore,
    evacuation: evacuationStore,
    tm: tmStore,
    sns: snsStore,
    viewConfig: viewConfigStore,
    fireBase: {},
    search: Search,
  },
  state: {},
  mutations: {},
  actions: {},
});
